// session.js
const KEY_PRODUCT = "mm_selected_product";
const KEY_DRAFT = "mm_form_draft";

export function saveSelectedProduct(product) {
  sessionStorage.setItem(KEY_PRODUCT, JSON.stringify(product));
}
export function getSelectedProduct() {
  const raw = sessionStorage.getItem(KEY_PRODUCT);
  return raw ? JSON.parse(raw) : null;
}
export function clearSelectedProduct() {
  sessionStorage.removeItem(KEY_PRODUCT);
}

export function saveDraft(draft) {
  sessionStorage.setItem(KEY_DRAFT, JSON.stringify(draft));
}
export function getDraft() {
  const raw = sessionStorage.getItem(KEY_DRAFT);
  return raw ? JSON.parse(raw) : null;
}
export function clearDraft() {
  sessionStorage.removeItem(KEY_DRAFT);
}